import React, { useState, useEffect } from 'react';
import WeRepresentPage from './WeRepresentPage';
import PrivacyPage from './PrivacyPage';
import VoorwaardenPage from './VoorwaardenPage';
import AIpolicyPage from './AIpolicyPage';
import CookieverklaringPage from './CookieverklaringPage';
import UnsubscribePage from './UnsubscribePage';
import AdminDashboard from './AdminDashboard';
import PublicLanguageDock from './components/PublicLanguageDock';
import { navigateTo } from './domainConfig';
import { useTranslation } from './i18n';

const BASE_TITLE = process.env.REACT_APP_SEO_TITLE || 'WeRepresent - Het moederbedrijf achter Betaaldsolliciteren & Werepresenttalent';

export default function AppWeRepresent() {
  const [path, setPath] = useState(window.location.pathname);
  const { t, language } = useTranslation();

  const normalizePath = (target) => {
    try {
      return new URL(target, window.location.origin).pathname;
    } catch (_) {
      return String(target || '/').split('?')[0].split('#')[0] || '/';
    }
  };

  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  // Houd de browser-tab-titel synchroon met de huidige route.
  useEffect(() => {
    if (path.startsWith('/admin')) {
      document.title = t('route_titles.admin');
    } else if (path === '/privacy') {
      document.title = t('route_titles.privacy');
    } else if (path === '/voorwaarden') {
      document.title = t('route_titles.voorwaarden');
    } else if (path === '/ai-policy') {
      document.title = t('route_titles.ai_policy');
    } else if (path === '/cookieverklaring') {
      document.title = t('route_titles.cookieverklaring');
    } else if (path === '/unsubscribe') {
      document.title = t('route_titles.unsubscribe');
    } else {
      document.title = t('route_titles.werepresent') || BASE_TITLE;
    }
  }, [path, t, language]);

  const navigate = (newPath) => {
    window.history.pushState({}, "", newPath);
    setPath(normalizePath(newPath));
  };

  const handleNavigate = (targetPath) => {
    navigateTo(targetPath, navigate);
  };

  const renderPublicPage = (page) => (
    <>
      <PublicLanguageDock />
      {page}
    </>
  );

  // Admin portal
  if (path.startsWith('/admin')) {
    return <AdminDashboard />;
  }

  // Legal pages
  if (path === '/privacy') {
    return renderPublicPage(<PrivacyPage onBack={() => navigate('/')} />);
  }
  if (path === '/voorwaarden') {
    return renderPublicPage(<VoorwaardenPage onBack={() => navigate('/')} onNavigate={handleNavigate} />);
  }
  if (path === '/ai-policy') {
    return renderPublicPage(<AIpolicyPage onBack={() => navigate('/')} />);
  }
  if (path === '/cookieverklaring') {
    return renderPublicPage(<CookieverklaringPage onBack={() => navigate('/')} />);
  }

  // Email unsubscribe
  if (path === '/unsubscribe') {
    return renderPublicPage(<UnsubscribePage onNavigate={handleNavigate} />);
  }

  // WeRepresent landing (root)
  return renderPublicPage(<WeRepresentPage onNavigate={handleNavigate} />);
}
